/**
 * 支持的日期范围（UTC）。范围由 golden 测试实测确认（见 docs/adr/0002）；
 * 超出范围一律抛错，不外推（需求契约 A6）。
 */
export const SUPPORTED_START = Date.UTC(1900, 0, 1);
export const SUPPORTED_END = Date.UTC(2100, 0, 1);

export class EphemerisRangeError extends RangeError {
  constructor(public readonly date: Date) {
    super(`Date ${Number.isNaN(date.getTime()) ? "Invalid Date" : date.toISOString()} is outside the supported range 1900-01-01..2100-01-01 (UTC)`);
    this.name = "EphemerisRangeError";
  }
}

export function isSupportedDate(date: Date): boolean {
  const t = date.getTime();
  return Number.isFinite(t) && t >= SUPPORTED_START && t <= SUPPORTED_END;
}

export function assertSupportedDate(date: Date): void {
  if (!isSupportedDate(date)) throw new EphemerisRangeError(date);
}

/** UTC 毫秒 → 儒略日（UT）。 */
export const julianDay = (date: Date): number => date.getTime() / 86400000 + 2440587.5;
